<template>
  <div>
    <el-input
      v-model="orderId"
      placeholder="请输入订单号"
      style="width:240px"
      @keyup.enter.native="searchOrder(orderId)"
    ></el-input>
    <el-button
      type="primary"
      @click="searchOrder(orderId)"
    >搜索</el-button>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      height="40%"
    >
      <template slot="empty">
        <p class="emptyText">{{ tableEmptyText }}</p>
      </template>

      <el-table-column
        prop="orderTime"
        label="下单时间"
      >
      </el-table-column>

      <el-table-column
        prop="parentId"
        label="父订单号"
      >
      </el-table-column>

      <el-table-column
        prop="orderId"
        label="订单号"
      >
      </el-table-column>

      <el-table-column
        prop="finishTime"
        label="完成时间"
      >
      </el-table-column>

      <el-table-column
        prop="orderStatusStr"
        label="订单状态"
      >
      </el-table-column>

      <el-table-column
        prop="bonusInvalidCodeStr"
        label="奖励状态"
      >
      </el-table-column>

      <el-table-column
        prop="estimateCosPrice"
        label="预估计佣金额"
      >
      </el-table-column>

      <el-table-column
        prop="actualCosPrice"
        label="实际计佣金额"
      >
      </el-table-column>

      <el-table-column
        prop="skuId"
        label="skuid"
      >
      </el-table-column>

      <el-table-column
        prop="skuName"
        label="商品名称"
      >
      </el-table-column>

    </el-table>
  </div>
</template>
<script>
import { getLgActivityOrder } from "@/api/cwactivityorder";
import store from "@/store";

export default {
  data() {
    return {
      startTime: "",
      endTime: "",
      tableData: [],
      tableEmptyText: "暂无数据",
      loading: false,
      orderId: ""
    };
  },
  methods: {
    async searchOrder(val) {
      if (!val) {
        alert("请输入订单号");
      } else {
        this.loading = true;
        await getLgActivityOrder({
          orderId: val
        }).then(res => {
          this.loading = false;
          if (res.code == 1000) {
            if (null == res.data) {
              this.tableData = [];
              this.tableEmptyText = "暂无数据";
            } else {
              this.tableData = res.data;
              this.total = res.data.total;
            }
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      }
    }
  }
};
</script>

